import ilustracionPrueba from '../assets/icons/ilustracion-prueba.webp';
import { categories as catalogCategories, featuredStores as catalogStores } from './catalog';

export const categories = catalogCategories.map((category) => category.name);

export const featuredStores = catalogStores.map((store) => store.name);

export const deals = [
    {
        id: 1,
        name: 'Pack ahorro tecnologia diaria',
        store: 'Amazon',
        category: 'Tecnologia',
        price: 19.99,
        oldPrice: 39.99,
        discount: '-50%',
        description: 'Accesorios utiles para movil, escritorio y casa con buena relacion precio-utilidad.',
        highlight: 'Top ventas',
        heat: 428,
        expires: 'Acaba hoy',
        image: ilustracionPrueba,
        url: 'https://www.amazon.es/'
    },
    {
        id: 2,
        name: 'Organizador inteligente para el hogar',
        store: 'AliExpress',
        category: 'Hogar',
        price: 8.95,
        oldPrice: 18.99,
        discount: '-53%',
        description: 'Solucion practica para ordenar cocina, bano o escritorio sin gastar de mas.',
        highlight: 'Ganga express',
        heat: 316,
        expires: 'Quedan pocas horas',
        image: ilustracionPrueba,
        url: 'https://www.aliexpress.com/'
    },
    {
        id: 3,
        name: 'Rutina beauty low cost',
        store: 'Druni',
        category: 'Belleza',
        price: 14.5,
        oldPrice: 24.95,
        discount: '-42%',
        description: 'Seleccion de cuidado personal con precio ajustado y alta rotacion en ofertas.',
        highlight: 'Muy buscado',
        heat: 271,
        expires: 'Precio temporal',
        image: ilustracionPrueba,
        url: 'https://www.druni.es/'
    },
    {
        id: 4,
        name: 'Gadget Xiaomi para casa conectada',
        store: 'Xiaomi',
        category: 'Tecnologia',
        price: 22.99,
        oldPrice: 34.99,
        discount: '-34%',
        description: 'Producto util para automatizar pequenas tareas del dia a dia con presupuesto bajo.',
        highlight: 'Buena compra',
        heat: 197,
        expires: 'Hasta fin de stock',
        image: ilustracionPrueba,
        url: 'https://www.mi.com/es/'
    },
    {
        id: 5,
        name: 'Oferta moda deportiva outlet',
        store: 'Adidas',
        category: 'Moda',
        price: 29.99,
        oldPrice: 59.95,
        discount: '-50%',
        description: 'Prendas y zapatillas seleccionadas para comprar en rebajas sin perder calidad.',
        highlight: 'Outlet',
        heat: 355,
        expires: 'Rebajas activas',
        image: ilustracionPrueba,
        url: 'https://www.adidas.es/'
    },
    {
        id: 6,
        name: 'Escapada de fin de semana con descuento',
        store: 'Viajes',
        category: 'Viajes',
        price: 49.0,
        oldPrice: 89.0,
        discount: '-45%',
        description: 'Ideas de escapadas economicas para reservar cuando el precio baja de verdad.',
        highlight: 'Temporal',
        heat: 143,
        expires: 'Fechas limitadas',
        image: ilustracionPrueba,
        url: 'https://www.booking.com/'
    }
];
